import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalBody,
    Input,
    FormGroup,
    Label,
    Spinner,
} from "reactstrap";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { formatDataBeforeSend, getVideoUrl } from "helpers/GeneralHelper";
import { updateRecruitment } from "model/AboutUsModel"; // ⬅️ replace with your actual API
import { useUserContext } from "libs/context/UserContext";
import moment from "moment";
import { updateFetchDetails } from "model/Partners";
import { requestACallBack, requestACancelCallBack } from "model/CandidateDetailsModel";
import { Link } from "react-router-dom";


const CandidateBackgroundStatusInfoModal = ({
    setBackgroundStatusInfoModalOpen,
    requestBackgroundStatusInfoModalOpen,
}) => {
    const inputFields = {
        FullName: "",
        CandidatePhone: "",
        CallBackDate: "",
        CallBackTime: "",
        Notes: "",
        // TimeZone: 'A/K'
    };
    const formatOptions = [];

    const [fields, setFields] = useState(inputFields);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);

    const closeModal = () => setBackgroundStatusInfoModalOpen(false);

    const { candidateDetailsData, fetchCandidateDetailsData } = useUserContext() || {};


    // ✅ Yup validation schema
    const validationSchema = Yup.object().shape({
        FullName: Yup.string().required("Full Name is required"),
        CandidatePhone: Yup.string()
            .matches(/^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/, "Invalid phone number")
            .required("Phone number is required"),
        CallBackDate: Yup.string().required("Date is required"),
        CallBackTime: Yup.string().required("Time is required"),
        Notes: Yup.string().required("Notes are required"),
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoading(true);

        try {
            await validationSchema.validate(fields, { abortEarly: false });
            setErrors({});

            const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
            let response = await requestACallBack(formData); // ⬅️ replace API call if needed

            if (response?.IsSuccess) {
                toast.success(response?.Message || "Callback request submitted!");
                setFields(inputFields);
                fetchCandidateDetailsData()
                setSubmitLoading(false);
                closeModal();
                setFields(inputFields);
                scrollToTop()
            } else {
                toast.error("Failed to submit callback request");
            }
        } catch (err) {
            if (err.inner) {
                const formErrors = {};
                err.inner.forEach((e) => {
                    formErrors[e.path] = e.message;
                });
                setErrors(formErrors);
            } else {
                toast.error("Something went wrong!");
            }
        } finally {
            setSubmitLoading(false);
        }
    };


    // ✅ Prefill from candidateDetailsData
    useEffect(() => {
        if (candidateDetailsData) {
            const rawDate = candidateDetailsData?.CallBack?.CallBackDateAppFormat;
            const rawTime = candidateDetailsData?.CallBack?.CallBackTime;


            setFields((prev) => ({
                ...prev,
                FullName: `${candidateDetailsData?.CallBack?.FullName || ""}`,
                CandidatePhone: candidateDetailsData?.CallBack?.CandidatePhone || "",
                Notes: candidateDetailsData?.CallBack?.Notes || "",
                CallBackDate: rawDate ? moment(rawDate).format("YYYY-MM-DD") : "",
                CallBackTime: rawTime || "",
            }));
        }
    }, [candidateDetailsData]);

    const scrollToTop = () => {
        window.scrollTo(0);
    };


    return (
        <Modal
            isOpen={requestBackgroundStatusInfoModalOpen}
            toggle={closeModal}
            backdrop="static"
            centered
            className="modal-full-height"

        >
            <ModalBody className="p-4 d-flex flex-column" style={{ height: "100vh" }}>
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-bold mb-0">Background Status</h5>
                    <Button close onClick={closeModal} />
                </div>

                {/* Form */}
                {/* <form onSubmit={handleSubmit} className="flex-grow-1 d-flex flex-column">
                    <div className="flex-grow-1 overflow-auto pe-2">
                        <FormGroup>
                            <Label>For More Information You Can Watch This Video</Label>
                            <p>
                                <Link
                                    to="https://www.google.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link-clr"
                                >
                                    {`https://www.google.com/`}
                                </Link>
                            </p>
                        </FormGroup>
                    </div>
                </form> */}

                <form onSubmit={handleSubmit} className="flex-grow-1 d-flex flex-column">
                    <div className="flex-grow-1 overflow-auto pe-2">
                        <FormGroup>
                            <Label>Get help on filling Background check</Label>
                            <p>
                                <Link
                                    to="https://www.youtube.com/watch?v=5kYgHPm7Kd0"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link-clr"
                                >
                                    {`https://www.youtube.com/watch?v=5kYgHPm7Kd0`}
                                </Link>
                            </p>
                            <div className="card-body d-flex gap-2 justify-content-between align-items-center mt-2">
                                <iframe
                                    width="100%"
                                    height="250"
                                    src={getVideoUrl(`https://www.youtube.com/watch?v=5kYgHPm7Kd0`)}
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                ></iframe>
                            </div>

                        </FormGroup>
                    </div>
                </form>

                {/* <form onSubmit={handleSubmit} className="flex-grow-1 d-flex flex-column">
                    <div className="flex-grow-1 overflow-auto pe-2">
                        <FormGroup>
                            <Label>Get help on filling Background check</Label>
                            <p>
                                <Link
                                    to="https://www.youtube.com/watch?v=5kYgHPm7Kd0"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link-clr"
                                >
                                    {`https://www.youtube.com/watch?v=5kYgHPm7Kd0`}
                                </Link>
                            </p>
                            <div className="card-body d-flex justify-content-center align-items-center mt-4">
                                <Link
                                    to="https://www.youtube.com/watch?v=5kYgHPm7Kd0"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link-clr"
                                >
                                    <button className="btn btn-primary-2 bg-dark" type="button">
                                        Click To View
                                    </button>
                                </Link>
                            </div>

                        </FormGroup>
                    </div>
                </form> */}
            </ModalBody>
        </Modal>
    );
};

export default CandidateBackgroundStatusInfoModal;
